import { authActionTypes } from './Auth.actionTypes';

const initialState = {
  authorized: false,
  loading: false,
  error: {},
  profile: {
    subscription: {},
  },
  signUp: {
    pending: false,
    success: false,
    error: false,
    data: {},
  },
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case authActionTypes.SET_STATE:
      return { ...state, ...action.payload };
    case authActionTypes.RESET_SIGNUP_STATE:
      return {
        ...state,
        signUp: {
          pending: false,
          success: false,
          error: false,
          data: {},
        },
      };
    // NEW: Handle subscription action
    case authActionTypes.PATCH_PROFILE:
      return {
        ...state,
        profile: {
          ...state.profile,
          ...action.payload,
        },
      };
    case authActionTypes.SET_SUBSCRIPTION_DATA:
      console.log(
        'Subscription: Auth reducer - SET_SUBSCRIPTION_DATA called with payload:',
        action.payload
      );
      return {
        ...state,
        profile: {
          ...state.profile,
          subscription: action.payload,
        },
      };
    default:
      return state;
  }
}
